import MembersTP from './members';
import LandsTP from './lands';
import RealtyTP from './realty';
import AnimalsTP from './animals';

export default {
  MembersTP,
  LandsTP,
  RealtyTP,
  AnimalsTP,
};
